import { Injectable } from '@angular/core';
import { Router, Resolve, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { VenueServiceeService } from '../venue-service/venue-servicee.service';
import { Observable } from 'rxjs/Observable';
import { map, catchError } from 'rxjs/operators';
import { HttpErrorResponse } from '@angular/common/http';
import 'rxjs/add/observable/of';


@Injectable()
export class VenueSettingResolveService implements Resolve<any>{

  constructor(
    private router: Router,
    private venue: VenueServiceeService
  ) { }

  resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
    
    return this.venue.getVenueSetting(route.queryParams.v_id).pipe(
      catchError((e:any) => {
        this.router.navigate(['/404']);
        // return Observable.throw(new Error(e.status));
        return Observable.of(false);
      }));
  }

}
